import React, { useMemo } from 'react';
import { Divider, Stack, styled } from '@mui/material';
import { ADDRESS, CONTACT_MAIL, WHATSAPP_REGULAR } from '../../constants';
import translation from 'i18n/translation.json';
import { ReactComponent as PhoneIcon } from 'assets/images/phone.svg';
import { ReactComponent as TimeIcon } from 'assets/images/time.svg';
import { ReactComponent as MailIcon } from 'assets/images/mail.svg';
import { ReactComponent as WhatsAppIcon } from 'assets/images/whatsapp-icon.svg';
import { getCallCenterLink, getFullFormattedNumber } from 'utils';
import { ContactLink, FooterColumns, ItemWrapper } from './style/general';
import { RowItemFooter, TextComponent } from './components';
import { FooterLicense } from './FooterLicense';
import { ManageCookiesBtn } from 'components/CookieConsent';

const CompactFooterColumns = styled(FooterColumns)(({ theme }) => ({
  gap: theme.spacing(2.5),
  paddingBottom: '30px',
  [theme.breakpoints.up('md')]: {
    gap: theme.spacing(4),
    paddingBottom: '40px',
  },
}));

const AddressColumn = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(0.5),
  flex: 1,
  maxWidth: 'unset',
  [theme.breakpoints.up('md')]: {
    maxWidth: '200px',
  },
}));

export const CompactFooter = () => {
  const { tel, fullPhone } = getCallCenterLink();

  const functionalLinks = useMemo(
    () => [
      { action: `tel:${tel}`, icon: <PhoneIcon />, label: fullPhone },
      {
        action: `https://wa.me/51${WHATSAPP_REGULAR}`,
        icon: <WhatsAppIcon />,
        label: getFullFormattedNumber(WHATSAPP_REGULAR),
        target: '_blank',
      },
      { action: `mailto:${CONTACT_MAIL}`, icon: <MailIcon />, label: CONTACT_MAIL },
    ],
    [],
  );

  return (
    <>
      <CompactFooterColumns>
        <AddressColumn>
          <TextComponent fontWeight={500}>{translation.registration.address}</TextComponent>
          <TextComponent fontWeight={400} variant="body2">
            {ADDRESS}
          </TextComponent>
        </AddressColumn>
        {functionalLinks.map(({ action, icon, label, target }) => (
          <ContactLink href={action} className="h4" key={label} target={target ?? ''}>
            <ItemWrapper>
              {icon}
              <TextComponent>{label}</TextComponent>
            </ItemWrapper>
          </ContactLink>
        ))}

        <ItemWrapper>
          <TimeIcon style={{ flexShrink: 0 }} />
          <TextComponent>{translation.account.workSchedule}</TextComponent>
        </ItemWrapper>
      </CompactFooterColumns>
      <ManageCookiesBtn customStyles={{ marginBottom: '12px' }} />
      <Divider />
      <RowItemFooter customstyles={{ borderBottom: 'unset' }}>
        <FooterLicense />
      </RowItemFooter>
    </>
  );
};
